import { StyleSheet, View } from 'react-native';

import { IconDelivery, Text, tokens } from '@fhs/ui';
import { useOrderContext } from '@fhs-legacy/frontend/src/state/order';
import { CHECKOUT_DELIVERY_ADDRESS } from '@fhs-legacy/frontend/src/utils/test-ids';

import { IDeliveryInputAddress } from '../../../../cart-types';
import NoRefundCallout from '../no-refund-callout';

export default function DeliveryAddress() {
  const { deliveryAddress } = useOrderContext();

  const formatDeliveryAddress = (address: IDeliveryInputAddress) => {
    return [address.addressLine1, address.addressLine2, address.city, address.state, address.zip]
      .filter(Boolean)
      .join(', ');
  };

  return (
    <View testID={CHECKOUT_DELIVERY_ADDRESS} style={styles.sectionBorder}>
      <View style={styles.section}>
        <View style={styles.iconCircle}>
          <IconDelivery size={24} />
        </View>
        <View style={{ flex: 1 }}>
          <Text.Ui size="xs">Deliver at:</Text.Ui>
          <Text.Heading numberOfLines={3} type="three">
            {formatDeliveryAddress(deliveryAddress)}
          </Text.Heading>
        </View>
      </View>
      <NoRefundCallout />
    </View>
  );
}

const styles = StyleSheet.create({
  section: {
    width: '100%',
    gap: 8,
    padding: 16,
    flexDirection: 'row',
    alignItems: 'center',
  },
  sectionBorder: {
    width: '100%',
    borderBottomColor: tokens.colors.$black10,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderTopColor: tokens.colors.$black10,
    borderTopWidth: StyleSheet.hairlineWidth,
  },
  iconCircle: {
    height: 40,
    width: 40,
    borderRadius: 40,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: tokens.colors.$houseLight,
  },
});
